import { createAction, props } from '@ngrx/store'
import { InitialiseData } from '../../models/state.model'
import { CompanySettingPreferencesAPIModel } from '../../models/api.model'

export const start_initializing = createAction('[initialize] start_initializing', props<{ comingFromLogin: boolean }>())
export const initialize_success = createAction(
  '[initialize] initialize_success',
  props<{ initializeData: InitialiseData; comingFromLogin: boolean }>()
)
export const initialize_failed = createAction('[initialize] initialize_failed', props<any>())

export const update_password_auto_generated = createAction('update_password_auto_generated', props<{ val: boolean }>())

export const fetch_company_setting_preferences_data = createAction(
  '[initialize] fetch_company_setting_preferences_data',
  props<{ groupId: string }>()
)

export const fetch_company_setting_preferences_data_success = createAction(
  '[initialize] fetch_company_setting_preferences_data_success',
  props<{ companySettingPreferences: CompanySettingPreferencesAPIModel }>()
)

export const initialize_route_after_success = createAction(
  '[initialize] initialize_route_after_success',
  props<{ initializeData: InitialiseData }>()
)

export const update_feedback_ui_status = createAction(
  '[initialize] update_feedback_ui_status',
  props<{ feedbackId: string; newStatus: string }>()
)

export const update_user_mobile_number = createAction(
  '[initialize] update_user_mobile_number',
  props<{ mobileNumber: string }>()
)
